// GETTERS
export const TICKET_GROUPS_GET_TICKET_GROUP =
  'ticket-groups/TICKET_GROUPS_GET_TICKET_GROUP';
export const TICKET_GROUPS_GET_LOADING =
  'ticket-groups/TICKET_GROUPS_GET_LOADING';
export const TICKET_GROUPS_GET_ERROR = 'ticket-groups/TICKET_GROUPS_GET_ERROR';
export const TICKET_GROUPS_GET_TICKETS =
  'ticket-groups/TICKET_GROUPS_GET_TICKETS';
export const TICKET_GROUPS_GET_TICKETS_PAGINATION =
  'ticket-groups/TICKET_GROUPS_GET_TICKETS_PAGINATION';
export const TICKET_GROUPS_GET_MOVEMENT_FILES =
  'ticket-groups/TICKET_GROUPS_GET_MOVEMENT_FILES';
export const TICKET_GROUPS_GET_MOVEMENT_FILE =
  'ticket-groups/TICKET_GROUPS_GET_MOVEMENT_FILE';
export const TICKET_GROUPS_GET_PROCESSED_FILE =
  'ticket-groups/TICKET_GROUPS_GET_PROCESSED_FILE';

// SETTERS
export const TICKET_GROUPS_SET_TICKET_GROUP =
  'ticket-groups/TICKET_GROUPS_SET_TICKET_GROUP';
export const TICKET_GROUPS_SET_TICKETS =
  'ticket-groups/TICKET_GROUPS_SET_TICKETS';
export const TICKET_GROUPS_SET_TICKETS_PAGINATION =
  'ticket-groups/TICKET_GROUPS_SET_TICKETS_PAGINATION';
export const TICKET_GROUPS_SET_MOVEMENT_FILES =
  'ticket-groups/TICKET_GROUPS_SET_MOVEMENT_FILES';
export const TICKET_GROUPS_SET_MOVEMENT_FILE =
  'ticket-groups/TICKET_GROUPS_SET_MOVEMENT_FILE';
export const TICKET_GROUPS_SET_PROCESSED_FILE =
  'ticket-groups/TICKET_GROUPS_SET_PROCESSED_FILE';
export const TICKET_GROUPS_SET_LOADING =
  'ticket-groups/TICKET_GROUPS_SET_LOADING';
export const TICKET_GROUPS_SET_ERROR = 'ticket-groups/TICKET_GROUPS_SET_ERROR';

// ACTIONS
export const TICKET_GROUPS_FETCH_TICKET_GROUP =
  'ticket-groups/TICKET_GROUPS_FETCH_TICKET_GROUP';
export const TICKET_GROUPS_FETCH_TICKETS =
  'ticket-groups/TICKET_GROUPS_FETCH_TICKETS';
export const TICKET_GROUPS_FETCH_MOVEMENT_FILES =
  'ticket-groups/TICKET_GROUPS_FETCH_MOVEMENT_FILES';
export const TICKET_GROUPS_FETCH_MOVEMENT_FILE =
  'ticket-groups/TICKET_GROUPS_FETCH_MOVEMENT_FILE';
export const TICKET_GROUPS_FETCH_PROCESSED_FILE =
  'ticket-groups/TICKET_GROUPS_FETCH_PROCESSED_FILE';
export const TICKET_GROUPS_FETCH_PROCESSED_FILES =
  'ticket-groups/TICKET_GROUPS_FETCH_PROCESSED_FILES';

// CLEAR ERROR
export const TICKET_GROUPS_CLEAR_ERROR =
  'ticket-groups/TICKET_GROUPS_CLEAR_ERROR';
